module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.completed) ? _c('md-list-item', [_c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.desc))]), _vm._v(" "), _c('md-progress', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hasError && _vm.areaStarted),
      expression: "!hasError && areaStarted"
    }],
    attrs: {
      "md-progress": _vm.progress
    }
  }), _vm._v(" "), _c('div', [(_vm.hasError) ? _c('md-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasError),
      expression: "hasError"
    }],
    staticClass: "md-accent md-raised",
    on: {
      "click": _vm.startProcess
    }
  }, [_vm._v("Tentar Novamente")]) : _vm._e(), _vm._v(" "), (_vm.hasError) ? _c('md-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasError),
      expression: "hasError"
    }],
    staticClass: "md-warn md-raised",
    on: {
      "click": _vm.openErrorDialog
    }
  }, [_vm._v("RESOLVER ERRO")]) : _vm._e()], 1), _vm._v(" "), (_vm.hasError) ? _c('sync-error-dialog', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasError),
      expression: "hasError"
    }],
    ref: "syncErrorDialog",
    attrs: {
      "error": _vm.error,
      "photoErrors": _vm.photoIndexErrors
    },
    on: {
      "restart": _vm.restart
    }
  }) : _vm._e()], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0da53283","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StructureSyncItem.vue
// module id = 823
// module chunks = 1